<template>
	<div>

		<div v-if="init">
			
			<div style="max-height:72vh;" class="border border-gray-300 mb-12 mt-12 overflow-x-scroll w-9/12" v-if="currentUserMarktimes.length != 0">
		
				<table class="table">
					<thead>
						<tr>
							<th style="top: -1px;" class="sticky z-20 w-1/12">Month</th>
							<th style="top: -1px;" class="sticky z-20 w-1/12">Year</th>
							<th style="top: -1px;" class="sticky z-20 w-1/12">Preview</th>
							<th style="top: -1px;" class="sticky z-20 w-2/12">
								<CellType>
                                    <template v-slot:type>Published</template>
                                    <template v-slot:by>by employee</template>
                                </CellType>
							</th>
							<th style="top: -1px;" class="sticky z-20 w-2/12" v-if="$store.getters['user/isEmployee'] || $store.getters['user/isAccounter']">
								<CellType>
                                    <template v-slot:type>Confirmed</template>
                                    <template v-slot:by>by team leader</template>
                                </CellType>
							</th>
							<th style="top: -1px;" class="sticky z-20 w-2/12">
								<CellType>
                                    <template v-slot:type>Checked</template>
                                    <template v-slot:by>by accounter</template>
                                </CellType>
							</th>
							<th style="top: -1px;" class="sticky z-20 w-2/12">
								<CellType>
                                    <template v-slot:type>Approved</template>
                                    <template v-slot:by>by manager</template>
                                </CellType>
							</th>
							<th style="top: -1px;" class="sticky z-20 w-1/12">Actions</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="marktime in sortedMarktimes" :key="marktime._key">
							<td>{{ showMonthName(marktime.month) }}</td>
							<td>{{ marktime.year }}</td>
							<td class="text-center">
								<router-link :to="{name: 'preview', params: {id: marktime._key}}" target="_blank" class="text-sm mr-2 btn btn-small btn-info">
									Preview
								</router-link>
							</td>
							<td>
								<div v-if="marktime.published">
									<div class="flex items-center leading-tight">
										<div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
										<div>published</div>
									</div>
									<div class="leading-tight">
										<span class="text-gray-500 italic text-xs">{{ getDate(marktime.publishedDate) }}</span>
									</div>
								</div>
								<div v-else class="text-center">
									<button @click="showPublish(marktime._key)" class="btn btn-small btn-secondary mr-2">
										Publish
									</button>
								</div>
							</td>
							<td v-if="$store.getters['user/isEmployee'] || $store.getters['user/isAccounter']">
								<div v-if="marktime.published">
									<div v-if="marktime.confirmed">
	                                    <div class="flex items-center leading-tight">
											<div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
											<div>confirmed</div>
										</div>
										<div class="leading-tight">
											<span class="text-gray-500 italic text-xs">{{ getDate(marktime.confirmedDate) }}</span>
										</div>
	                                </div>
	                                <div v-else class="flex items-center">
	                                    <div class="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
	                                    <div>not yet</div>
	                                </div>
								</div>
							</td>
							<td>
								<div v-if="marktime.published">
									<div v-if="marktime.checked">
	                                    <div class="flex items-center leading-tight">
											<div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
											<div>checked</div>
										</div>
										<div class="leading-tight">
											<span class="text-gray-500 italic text-xs">{{ getDate(marktime.checkedDate) }}</span>
										</div>
	                                </div>
	                                <div v-else class="flex items-center">
	                                    <div class="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
	                                    <div>not yet</div>
	                                </div>
								</div>
							</td>
							<td>
								<div v-if="marktime.published">
									<div v-if="marktime.approved">
	                                    <div class="flex items-center leading-tight">
											<div class="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
											<div>approved</div>
										</div>
										<div class="leading-tight">
											<span class="text-gray-500 italic text-xs">{{ getDate(marktime.approvedDate) }}</span>
										</div>
	                                </div>
	                                <div v-else class="flex items-center">
	                                    <div class="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
	                                    <div>not yet</div>
	                                </div>
								</div>
							</td>
							
							<td>

								<div class="flex items-center">
									<router-link class="text-gray-600 cursor-pointer tooltip inline-block mr-4" v-if="!marktime.published" :to="{name: 'marktime-edit', params: {id: marktime._key}}" tag="span">
										<Zondicon icon="edit-pencil" class="w-4 fill-current" />
										<span class="tooltip-text -ml-2">Edit</span>
									</router-link>
									
									<span class="text-gray-600 cursor-pointer tooltip inline-block mr-4" v-if="!marktime.published" @click="showConfirm(marktime._key)">
										<Zondicon icon="trash" class="w-4 fill-current" />
										<span class="tooltip-text -ml-4">Delete</span>
									</span>
								</div>

							</td>
						</tr>
					</tbody>
				</table>

			</div>
			<div v-else  class="mb-12 mt-12">
				<div class="ui visible message">
					<p>What? You do not have any marktime? Are you serious? <router-link class="underline" :to="{ name: 'marktime-new'}">Create one!</router-link></p>
				</div>
			</div>

		</div>

		<div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>

		<SimpleModal v-if="deleteModal" @action="deleteMarktime" @close="deleteModal = false" :btnClass="'btn-danger'">
			<template v-slot:title>Delete this marktime</template>
			<template v-slot:body>Are you sure you want to delete this marktime?</template>
			<template v-slot:button>Delete</template>
		</SimpleModal>

		<SimpleModal v-if="publishModal" @action="publish" @close="publishModal = false" :btnClass="'btn-secondary'">
			<template v-slot:title>Publish this marktime</template>
			<template v-slot:body>Are you sure you want to publish this marktime?</template>
			<template v-slot:button>Publish</template>
		</SimpleModal>


	</div>
</template>


<script>
import { mapState } from "vuex";
import { db, auth } from '@/firebase'
import moment from 'moment'
import Zondicon from 'vue-zondicons'

import SimpleModal from '@/components/SimpleModal.vue'
import CellType from '@/components/CellType.vue'

export default {

	data() {
		return {
			deleteModal: false,
			publishModal: false,
			key: null
		}
	},

	computed: {

		...mapState({
			currentUserMarktimes: state => state.user.marktimes
		}),

		init() {
			if (this.currentUserMarktimes) return true
			return false
		},

		sortedMarktimes() {
			var marktimesArray = Object.values(this.currentUserMarktimes)

			marktimesArray = marktimesArray.sort((a, b) => {

				var aTime = new Date(a.year, a.month, 1)
				var bTime = new Date(b.year, b.month, 1)

				return bTime - aTime;
			})

			return marktimesArray;
		},

	},

	components: {
		SimpleModal,
		Zondicon,
		CellType
	},

	methods: {
        showMonthName(i) {
            return moment({
                month: i
            }).format('MMMM')
		},

		getDate(time) {
            if (time) {
                return moment(time.seconds * 1000).format('DD. MM. YYYY HH:mm')
            }
            return ''
        },

		showConfirm(key) {
			this.deleteModal = true
			this.key = key
		},

		showPublish(key) {
			this.publishModal = true
			this.key = key
		},

		deleteMarktime() {

			db
			.collection("marktimes")
			.doc(this.key)
			.delete()
			.then(() => {
				this.deleteModal = false
				this.$toasted.show(`Deleted successfully!`, {
					type: 'success'
				})
			})
			.catch(error => {
				this.deleteModal = false
				this.$toasted.show(`Error: ${error}`, {
					type: 'error'
				})
			});
		},

		publish() {
			
            db
            .collection("marktimes")
            .doc(this.key)
            .update({
                published: true,
                publishedDate: new Date()
            })
            .then(() => {
				this.publishModal = false
                this.$toasted.show(`Published successfully!`, {
                    type: 'success'
                })
            })
            .catch(error => {
				this.publishModal = false
                this.$toasted.show(`Error: ${error}`, {
                    type: 'error'
                })
            });
		},
	},

	created() {
		if (!this.currentUserMarktimes) this.$store.dispatch('user/getMarktimes')

		this.$store.commit('SET_TITLE', 'My Marktimes')
	}
};
</script>
